import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { Form, FormState } from '../../types/form';

const initialState: FormState = {
  items: [],
  selectedForm: null,
  isLoading: false,
  error: null,
};

const formSlice = createSlice({
  name: 'forms',
  initialState,
  reducers: {
    setForms: (state, action: PayloadAction<Form[]>) => {
      state.items = action.payload;
      state.isLoading = false;
      state.error = null;
    },
    addForm: (state, action: PayloadAction<Form>) => {
      state.items.push(action.payload);
    },
    updateForm: (state, action: PayloadAction<Form>) => {
      const index = state.items.findIndex(item => item.formId === action.payload.formId);
      if (index !== -1) {
        state.items[index] = action.payload;
      }
    },
    deleteForm: (state, action: PayloadAction<string>) => {
      state.items = state.items.filter(item => item.formId !== action.payload);
    },
    setSelectedForm: (state, action: PayloadAction<Form | null>) => {
      state.selectedForm = action.payload;
    },
    setLoading: (state, action: PayloadAction<boolean>) => {
      state.isLoading = action.payload;
    },
    setError: (state, action: PayloadAction<string | null>) => {
      state.error = action.payload;
      state.isLoading = false;
    },
    clearForms: state => {
      state.items = [];
      state.selectedForm = null;
      state.isLoading = false;
      state.error = null;
    },
  },
});

export const {
  setForms,
  addForm,
  updateForm,
  deleteForm,
  setSelectedForm,
  setLoading,
  setError,
  clearForms,
} = formSlice.actions;

export default formSlice.reducer;
